import { render, staticRenderFns } from "./sahsi.vue?vue&type=template&id=59ac9c2c&scoped=true&"
import script from "./sahsi.vue?vue&type=script&lang=js&"
export * from "./sahsi.vue?vue&type=script&lang=js&"
import style0 from "./sahsi.vue?vue&type=style&index=0&id=59ac9c2c&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "59ac9c2c",
  null
  
)

export default component.exports